export const END_POINT = Object.freeze({
	SCHEME_PAYMENT: '/payment/pay/scheme'
});
